import { Component, Input } from '@angular/core';

type Position =
  | 'Co-Organizer'
  | 'Director of Communications'
  | 'Director of Operations'
  | 'Director of Technology'
  | 'Founder';

@Component({
  selector: 'angular-community-profile-card',
  templateUrl: './profile-card.component.html',
  styleUrls: ['./profile-card.component.scss'],
})
export class ProfileCardComponent {
  _name: string;
  altText: string;
  twitterLink: string;
  linkedinLink: string;
  showAll = false;

  @Input() set name(name: string) {
    this._name = name;
    this.altText = `${name} profile picture`;
  }

  @Input() img = '';
  @Input() bio = '';

  @Input() set twitterHandle(handle: string) {
    this.twitterLink = `https://twitter.com/${handle}`;
  }

  @Input() set linkedinHandle(handle: string) {
    this.linkedinLink = `https://www.linkedin.com/in/${handle}`;
  }

  @Input() position: Position = 'Co-Organizer';
  @Input() websiteLink = '';
}
